
@if(vm$ | async; as vm){
    <div >
        <app-player-header  style="margin-left: 20px;" [Player]="vm.player"></app-player-header>
    </div>
    <mat-divider></mat-divider>
   

<!-- OVERALL GRADES -->
<!-- <app-report-overall-grades-new 
    [TotalQualityText]="this.Report.TotalQualityText"
    [TotalQuality]="this.Report.TotalQuality.Ranking"
    [GamePerformanceText]="this.Report.GamePerformanceText ?? ''"
    [GamePerformance]="this.Report.GamePerformance==null ? 0 : this.Report.GamePerformance.Ranking"
    [CapacityText]="this.Report.PlayerCapacityText"
    [Capacity]="this.Report.PlayerCapacity?.Ranking ?? 0"
    [PlayerTypeText]="this.Report.PlayerTypeText"
    [PlayerType]="this.Report.PlayerType?.Ranking">
</app-report-overall-grades-new> -->
<!-- Example usage of modernized component:-->
<!--     <app-report-overall-grades-new  
            [gamePerformanceText]="vm.report.GamePerformanceText"
            [gamePerformance]="vm.report.GamePerformance==null ? 0 : vm.report.GamePerformance.Ranking"
            [positionText]="vm.report.SCReport.PositionText"
            [positionId]="vm.report.SCReport.PositionId"
            [capacityText]="vm.report.PlayerCapacityText"
            [capacity]="vm.report.PlayerCapacity?.Ranking"
            [totalQualityText]="vm.report.TotalQualityText"
            [totalQuality]="vm.report.TotalQuality.Ranking"
            [playerTypeText]="vm.report.PlayerTypeText"
            [playerType]="vm.report.PlayerType?.Ranking"
            [currentLevelRankingText]="vm.report.SCReport.CurrentLevelRankingText"
            [currentLevelRanking]="vm.report.SCReport.CurrentLevelRanking">
    </app-report-overall-grades-new> -->
    <app-report-overall-grades  
            [GamePerformanceText]="vm.report.GamePerformanceText"
            [GamePerformance]="vm.report.GamePerformance==null ? 0 : vm.report.GamePerformance.Ranking"
            [PositionText]="vm.report.SCReport.PositionText"
            [PositionId]="vm.report.SCReport.PositionId" 
            [CapacityText]="vm.report.PlayerCapacityText"
            [Capacity]="vm.report.PlayerCapacity?.Ranking"
            [TotalQualityText]="vm.report.TotalQualityText"
            [TotalQuality]="vm.report.TotalQuality.Ranking"
            [PlayerTypeText]="vm.report.PlayerTypeText"
            [PlayerType]="vm.report.PlayerType?.Ranking"
            [CurrentLevelRankingText]="vm.report.SCReport.CurrentLevelRankingText"
            [CurrentLevelRanking]="vm.report.SCReport.CurrentLevelRanking">
    </app-report-overall-grades>
    

<mat-divider></mat-divider>

<!-- SCOUT COMMENT -->
<div style="min-height: 50px;" [ngClass]="getTextClass(vm.report)">
    {{getTextType(vm.report, 1)}}
</div>
<mat-divider></mat-divider>

<!-- SKILLS -->
<app-report-overall-skillsgroup 
    [SkillsGroups]="vm.report.SkillGroups"
  ></app-report-overall-skillsgroup>



<br/>


 @if (vm.report.Game) {
        <mat-divider></mat-divider>
    <!--  <app-game-header-tight style="margin-left: 20px;" [Game]="vm.report.Game" [Statistics]="vm.report.GameStatistics"></app-game-header-tight> -->
     <app-game-header-small style="margin-left: 20px;" [Game]="vm.report.Game" [Statistics]="vm.report.GameStatistics"></app-game-header-small>
        <mat-divider></mat-divider>
    }
<mat-divider></mat-divider>
<!-- REPORT METADATA -->
 <br/>
<div style="font-size: 12px; display: flex; align-items: center; ">
    <mat-icon style="font-size: 18px;"> location_on</mat-icon>
        {{vm.report.SCReport.Location}}
        @if(vm.report.SCReport.ScoutingSourceId!=0){
    
    <div class="source">       
            {{vm.report.SCReport.ScoutingSourceText}}
    </div>
}

</div>

<div style="font-size: 12px; display: flex; align-items: center;">
    <mat-icon style="font-size: 18px;">person</mat-icon>
    {{vm.report.SCReport.ScoutLastName}}, {{vm.report.SCReport.ScoutFirstName}}    
    
</div>
<div style="color: gray;font-size: 12px;"> {{getTimeAgo(vm.report)}} ({{vm.report.SCReport.ReportDate | date:'yyyy-MM-dd HH:mm' }})</div>

}



